var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSlidesFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37.129,
    viewBox: "0 0 41 37.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.6 -3.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1341.1,18.729V-12h34.721V18.729Zm12.668-7.859h14.066V7.82h-14.066Zm-6.568,0h3.049V7.82H1347.2Zm6.568-5.983h14.066V1.838h-14.066Zm-6.568,0h3.049V1.838H1347.2Zm6.568-6.1h14.066v-3.05h-14.066Zm-6.568,0h3.049v-3.05H1347.2Zm30.967,13.138V-14.468H1347.9V-17.4h33.2V11.926Z",
    transform: "translate(-1338 21)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlidesFill);
export default __webpack_public_path__ + "static/media/icon-slides-fill.a666d53c.svg";
export { ForwardRef as ReactComponent };